import {Directive, ElementRef, Renderer2, OnInit, HostListener} from '@angular/core';

@Directive({
  selector: '[mti-color-hover-item]'
})
export class MtiColorHoverItemDirective implements OnInit {
  public color: String = '#fff';
  public fuenteColor: String = '#fff';

  constructor(public el: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit() {
  }

  @HostListener('mouseenter') mouseover(){
    const theme = JSON.parse(localStorage.getItem('theme'));
    this.color = theme.groupElements1;
    this.fuenteColor = theme.color1;
    this.renderer.setStyle(this.el.nativeElement, 'background-color', this.color);
    this.renderer.setStyle(this.el.nativeElement, 'color', this.fuenteColor);
  }

  @HostListener('mouseleave') mouseleave(){
    this.renderer.removeStyle(this.el.nativeElement, 'background-color');
    this.renderer.removeStyle(this.el.nativeElement, 'color');
  }
}
